module.exports = __webpack_public_path__ + "img/Kontakt 20-12.1bfe30b7.svg";